import React from "react";

export const LoaderScreen = ({ loader }) => {
  const { mostrar, alerta, error, mensaje } = loader;
  if (mostrar === undefined || mostrar === null || mostrar === false) return;
  if (alerta === false && mostrar === true)
    return (
      <div className="loading-screen">
        <div className="loading-screen-container">
          <span className="loader"></span>
        </div>
      </div>
    );

  if (mostrar === true && alerta === true) return <div>"Mensaje</div>;
};
